import React, { useState } from "react";
import { Squash as Hamburger } from "hamburger-react";
import { Link as ScrollLink } from "react-scroll";
import { useScrollYPosition } from "react-use-scroll-position";

import "./Navbar.css";

function Navbar() {
  const [isOpen, setOpen] = useState(false);
  const [fadeLink, setFadeLink] = useState("");
  const [fadeAll, setFadeAll] = useState(false);

  const fadeMenu = () => {
    setFadeAll(true);
    setTimeout(() => {
      setFadeLink("");
      setFadeAll(false);
      setOpen(!isOpen);
    }, 250);
  };

  const navlinks = ["ABOUT", "SKILLS", "PROJECTS", "CONTACT"];

  const [scrollPosition, setScrollPosition] = useState(false);
  const scrollY = useScrollYPosition();
  if (scrollY > 150 && scrollPosition === false) {
    setScrollPosition(true);
  } else if (scrollY < 150 && scrollPosition === true) {
    setScrollPosition(false);
  }

  return (
    <div
      className={
        !scrollPosition
          ? "navigation-container white-text"
          : "navigation-container show-background"
      }
    >
      <div className="title-container">
        <ScrollLink className="title" to={`box-0`}>
          ERIK HENDRIKSON
        </ScrollLink>
      </div>
      <div
        className="hamburger"
        onClick={() => {
          setOpen(!isOpen);
        }}
      >
        {!scrollPosition ? (
          <Hamburger toggled={isOpen} color="white" />
        ) : (
          <Hamburger toggled={isOpen} color="black" />
        )}
      </div>
      {!isOpen ? null : (
        <>
          {" "}
          <ul id="mobile-ul" className={!fadeAll ? null : "fade-menu"}>
            {navlinks.map((link, i) => {
              return (
                <li
                  key={i}
                  style={{
                    animation: `growScreen 0.25s ${200 * i}ms backwards`,
                  }}
                  className={`navlink ${
                    fadeLink === link ? "fade-link" : null
                  }`}
                >
                  <ScrollLink
                    onClick={() => {
                      setFadeLink(link);
                      setTimeout(() => {
                        fadeMenu();
                      }, 250);
                    }}
                    key={i}
                    spy={true}
                    smooth={true}
                    duration={250}
                    className="navlink navlink-top"
                    to={`box-${i + 1}`}
                  >
                    {link}
                  </ScrollLink>
                </li>
              );
            })}
          </ul>
        </>
      )}
      <nav className="navigation">
        {navlinks.map((link, i) => {
          return (
            <ScrollLink
              key={i}
              spy={true}
              smooth={true}
              duration={250}
              className="navlink navlink-top"
              activeClass="active-link"
              to={`box-${i + 1}`}
            >
              {link}
            </ScrollLink>
          );
        })}
      </nav>
    </div>
  );
}

export default Navbar;
